import { Application } from '@feathersjs/feathers'
import { CreditCardError } from '../components/ApplicationProgress/CreditCardSubmitted/types'
import {
  CardStatus,
  CreditAcceptResponse,
  CreditCardDetails,
  CreditCardStatusResponse,
  GENERIC,
  REJECTED
} from '../domain/creditCard'
import { addDataSource } from './user.service'

/**
 * Accept credit offer
 * @param application
 * @param applicationId
 * @returns
 */
export const acceptCreditOffer =
  (application: Application) =>
  async (applicationId: string): Promise<CreditAcceptResponse> => {
    const addCreditCardSource = addDataSource(application)
    await addCreditCardSource()
    return application.service('credit/cards').create({ applicationId })
  }

/**
 * Checks status on
 * @param application
 * @param cardId
 * @returns
 */
export const checkCreditCardStatus =
  (application: Application) =>
  (cardId: string): Promise<CreditCardStatusResponse> => {
    return application.service('credit/cards').get(cardId)
  }

/**
 *
 * @param application
 * @param cardId
 * @returns
 */
export const getCreditCardDetails =
  (application: Application) =>
  (cardId: string): Promise<CreditCardDetails> => {
    return application.service(`credit/cards/${cardId}/details`).get(null)
  }

export const isReady = (status: CardStatus): boolean =>
  status === CardStatus.ready

export const isWaiting = (status: CardStatus): boolean =>
  status === CardStatus.waiting

export const isRejected = (status: CardStatus): boolean =>
  status === CardStatus.rejected

export const isErrored = (status: CardStatus): boolean =>
  status === CardStatus.errored || isRejected(status)

export const mapCreditCardError = (status: CardStatus): CreditCardError => {
  switch (status) {
    case CardStatus.rejected:
      return REJECTED
    case CardStatus.errored:
      return GENERIC
    default:
      return GENERIC
  }
}
